import React, { Component } from 'react';
import {
    Grid,
    Typography,
    FormControlLabel, Switch,
    TextField, Modal, Button,
    Paper, MenuItem,
    
} from '@material-ui/core';
import ProviderTypeService from '../../../tools/ProviderTypeService';

import MultiSelect from '../../../components/MultiSelect';

//msgs
import { msgAction, msgSimple } from '../../../actions/snackbarActions';
import { connect } from 'react-redux';


class ModalProviders extends Component {
    constructor(props) {
        super(props)
        this.state = {
            open: '',
            height:'',
            modal: {
                id: "",
                active: true,
                name: "",
                abbreviation: "",
                base: "",
                department: "",
                contact: "",
                email: "",
                phone1: "",
                phone2: "",
                observations: "",
                supplier_types: [],
            },
            providerTypes: [
            ]
        }
    }

    componentWillMount(){
        ProviderTypeService.getActive().then( async result => {
            if (result.ok) {
                let providerTypes = await result.response.map(element => ({
                    value: element.id,
                    label: element.name
                }))
                this.setState({providerTypes});

            }
        })
    }

    _handleIdMultiSelect = async value => {
        if (value) {
            return await value.map(element => ({ value: element.id, label: element.name }))
        }
        return null;
    }

    onRender = async () => {

        if (this.props.modal.id !== 'new'){
            let { 
                supplier_types,
            } = this.props.modal;
            await this.setState({
                modal: {
                    ...this.props.modal,
                    supplier_types: await this._handleIdMultiSelect(supplier_types),
            }})
        }
        else
            this.setState({
                modal: {
                    id: "new",
                    active: true,
                    name: "",
                    abbreviation: "",
                    base: "",
                    department: "",
                    contact: "",
                    email: "",
                    phone1: "",
                    phone2: "",
                    observations: "",
                    supplier_types:[]
                    
                }
            })
    }


    render() {
        return (
            <Modal
                style={{overflowY:'auto'}}
                open={this.props.openModal}
                onRendered={this.onRender}
            >
                <Grid container justify="center" alignItems="center" style={{ height: '100%', width: '100%'}} xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid style={{ height:'100%', padding:25 }} item container xs={12} sm={8} md={8} lg={8} xl={6}>
                        <Paper style={{ height: '100%', width: '100%', overflowY: 'auto' }} >
                            <Grid style={{ overflowY: 'auto', padding: 20 }} container>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Typography style={{ marginTop: 10 }} variant="title" id="modal-title">
                                        {this.props.modal.id === 'new' ? "Novo Fornecedor" : "Editar Fornecedor"}
                                    </Typography>
                                </Grid>
                                <Grid container spacing={24} style={{ marginTop: 10 }}>
                                    <Grid item xs={12} sm={3} md={2} lg={2} xl={2}>
                                        <Typography variant="subheading" id="modal-title" style={{ fontSize: 15 }} >
                                            Ativo
                                        </Typography>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={this.state.modal.active}
                                                    color="primary"
                                                    value="gilad"
                                                    onChange={event => {
                                                        let { modal } = this.state;
                                                        this.setState({ modal: { ...modal, active: event.target.checked } })
                                                    }}
                                                />
                                            }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={24}  >
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <TextField
                                            id="name"
                                            required
                                            label="Nome"
                                            style={{ width: '100%' }}
                                            value={this.state.modal.name}
                                            margin="normal"
                                            onChange={event => {
                                                let { modal } = this.state;
                                                this.setState({ modal: { ...modal, name: event.target.value } })
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <TextField
                                            id="name"
                                            label="Razão Social"
                                            style={{ width: '100%' }}
                                            value={this.state.modal.abbreviation}
                                            onChange={event => {
                                                let { modal } = this.state;
                                                this.setState({ modal: { ...modal, abbreviation: event.target.value } })
                                            }}
                                            margin="normal"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <TextField
                                            id="department"
                                            label="Departamento"
                                            style={{ width: '100%' }}
                                            value={this.state.modal.department}
                                            onChange={event => {
                                                let { modal } = this.state;
                                                this.setState({ modal: { ...modal, department: event.target.value } })
                                            }}
                                            margin="normal"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <TextField
                                            id="base_icao_iata"
                                            label="ICAO(s) IATA(s)"
                                            style={{ width: '100%' }}
                                            value={this.state.modal.base}
                                            onChange={event => {
                                                let { modal } = this.state;
                                                this.setState({ modal: { ...modal, base: event.target.value } })
                                            }}
                                            margin="normal"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <MultiSelect
                                            value={this.state.modal.supplier_types}
                                            required
                                            suggestions={this.state.providerTypes}
                                            placeholder='Tipos de fornecedores'
                                            label="Tipo de fornecedores"
                                            onChange={value => {
                                                let { modal } = this.state;
                                                this.setState({ modal: { ...modal, supplier_types: value } })
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={24} >
                                    
                                </Grid>
                                <Grid container spacing={24} >
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6} >
                                        <TextField
                                            id="contact"
                                            label="Contato"
                                            style={{ width: '100%' }}
                                            value={this.state.modal.contact}
                                            onChange={event => {
                                                let { modal } = this.state;
                                                this.setState({ modal: { ...modal, contact: event.target.value } })
                                            }}
                                            margin="normal"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <TextField
                                            id="email"
                                            label="E-mail"
                                            style={{ width: '100%' }}
                                            value={this.state.modal.email}
                                            onChange={event => {
                                                let { modal } = this.state;
                                                this.setState({ modal: { ...modal, email: event.target.value } })
                                            }}

                                            margin="normal"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={16}>
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}  >
                                        <TextField
                                            id="phone"
                                            label="Telefone"
                                            style={{ width: '100%' }}
                                            value={this.state.modal.phone1}
                                            onChange={event => {
                                                let { modal } = this.state;
                                                this.setState({ modal: { ...modal, phone1: event.target.value } })
                                            }}

                                            margin="normal"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <TextField
                                            id="phone"
                                            label="Outro Telefone"
                                            style={{ width: '100%' }}
                                            value={this.state.modal.phone2}
                                            onChange={event => {
                                                let { modal } = this.state;
                                                this.setState({ modal: { ...modal, phone2: event.target.value } })
                                            }}

                                            margin="normal"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={16}>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <TextField
                                            id="observation"
                                            label="Observações"
                                            style={{ width: '100%' }}
                                            value={this.state.modal.observations}
                                            onChange={event => {
                                                let { modal } = this.state;
                                                this.setState({ modal: { ...modal, observations: event.target.value } })
                                            }}

                                            margin="normal"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Button
                                        style={{ float: 'right' }}
                                        color="secondary"
                                        onClick={() => this.props.func()}
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        style={{ float: 'right' }}
                                        color="primary"
                                        onClick={() => {
                                            if(this.state.modal.name !=='' && this.state.modal.supplier_types.length !==0)
                                                this.props.handleSave(this.state.modal)
                                            else
                                                this.props.msgSimple('Preencha os campos obrigatórios.')
                                        }}
                                    >
                                        Salvar
                                    </Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </Modal>
        );
    }
}


const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {
    msgSimple
};

export default connect( mapStateToProps, mapDispatchToProps)(ModalProviders)



// WEBPACK FOOTER //
// ./src/routes/settings/providers/Modal.js